(() => {
  const enableSlider = (section) => {
    const track = section.querySelector('.nc-related__track');
    if (!track || section.querySelector('.nc-related__controls')) return;
    const controls = document.createElement('div');
    controls.className = 'nc-related__controls';
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = direction < 0 ? '←' : '→';
      button.setAttribute('aria-label', direction < 0 ? '前の記事を表示' : '次の記事を表示');
      button.addEventListener('click', () => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const count = window.matchMedia('(min-width: 750px)').matches ? 4 : 2;
        track.scrollBy({left: direction * step * count, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      controls.append(button);
      return button;
    });
    const update = () => {
      controls.hidden = track.scrollWidth <= track.clientWidth + 1;
      buttons[0].disabled = track.scrollLeft <= 1;
      buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    section.append(controls);
    track.addEventListener('scroll', update, {passive:true});
    const observer = new ResizeObserver(() => { if (!section.isConnected) observer.disconnect(); else update(); });
    observer.observe(track);
    update();
  };
  const initialize = (scope) => {
    scope.querySelectorAll('[data-nc-related]').forEach(async (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('.nc-related__section:not([data-nc-tag-section])').forEach(enableSlider);
      root.querySelectorAll('[data-nc-tag-section]').forEach(async section => {
      const tags = [section.dataset.tag];
      const limit = Math.min(Number(root.dataset.limit) || 7, 7);
      const seen = new Set([root.dataset.current]);
      const grid = section.querySelector('[data-nc-tag-results]');
      const query = tags.map(tag => 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"').join(' OR ');
      let page = 1;
      try {
        while (page && grid.children.length < limit && root.isConnected) {
          const url = new URL(root.dataset.search, window.location.origin);
          url.searchParams.set('type', 'article');
          url.searchParams.set('q', query);
          url.searchParams.set('view', 'nc-related');
          url.searchParams.set('page', page);
          url.searchParams.set('options[prefix]', 'none');
          const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('Related article request failed');
          const data = await response.json();
          for (const article of data.articles) {
            if (seen.has(article.id) || !article.tags.some(tag => tags.includes(tag))) continue;
            seen.add(article.id);
            const link = document.createElement('a');
            link.className = 'nc-related__card';
            link.href = article.url;
            const media = document.createElement('div');
            media.className = 'nc-related__media';
            if (article.image) {
              const image = document.createElement('img');
              image.className = 'nc-related__image';
              image.src = article.image;
              image.alt = '';
              image.loading = 'lazy';
              image.width = 720;
              image.height = 720;
              media.append(image);
            }
            link.append(media);
            const content = document.createElement('div');
            content.className = 'nc-related__content';
            const badges = document.createElement('div');
            badges.className = 'nc-related__tags';
            for (const tag of article.tags.slice(0, 2)) {
              const badge = document.createElement('span');
              badge.className = 'nc-related__tag';
              badge.textContent = tag;
              badges.append(badge);
            }
            content.append(badges);
            const title = document.createElement('h3');
            title.className = 'nc-related__title';
            title.textContent = article.title;
            content.append(title);
            if (article.date && article.datetime) {
              const date = document.createElement('time');
              date.className = 'nc-related__date';
              date.dateTime = article.datetime;
              date.textContent = article.date;
              content.append(date);
            }
            link.append(content);
            grid.append(link);
            section.hidden = false;
            if (grid.children.length >= limit) break;
          }
          page = data.next && data.next > page ? data.next : null;
        }
        if (grid.children.length) {
          const all = document.createElement('a');
          all.className = 'nc-related__card nc-related__all';
          all.href = section.dataset.allUrl;
          all.textContent = tags.join('・') + 'の全ての記事を見る';
          grid.append(all);
          enableSlider(section);
        }
      } catch (error) {
        console.warn('NATURALCOSMO related articles:', error.message);
      }
      });
    });
  };
  initialize(document);
  if (!window.ncRelatedListener) {
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    window.ncRelatedListener = true;
  }
})();
